/* eslint-disable @typescript-eslint/no-explicit-any */

export const CZ = 'cs'
export const EN = 'en'

export const _ = (message: string) => {
  const messages = (window as any).messages
  if (messages && messages[message]) {
    return messages[message][0]
  }

  return message
}

export function getLang (): string {
  return document.querySelector('html')?.getAttribute('lang') || CZ
}

export function localeFallback (fieldCz: string, fieldEn: string) {
  const lang = getLang()

  if (CZ === lang) {
    return fieldCz && fieldCz.length > 0 ? fieldCz : fieldEn
  } else {
    return fieldEn && fieldEn.length > 0 ? fieldEn : fieldCz
  }
}
